import React from 'react'

const FindInfluencer = () => {
  return (
    <div>
      <h1>Find</h1>
    </div>
  )
}

export default FindInfluencer
